// web/src/route-paths.js
//
// Every path App.jsx renders, declared once so the nav can be held to it:
// assertRoutesCoverSections (layout/nav-items.js) throws at import time if a section has no
// route. Support's pages live under /support (support-path.js); '/' is the platform shell's;
// '*' is Support's not-found inside /support.
import { supportPath } from './support-path.js';

const SUPPORT_PAGES = [
  '/', '/tickets', '/tickets/new', '/tickets/drafts/team', '/tickets/drafts/:draftId',
  '/tickets/:publicRef',
  '/search',
  '/customers', '/customers/send-lists', '/customers/:id',
  '/reports', '/reports/:reportId',
  '/admin', '/admin/schedules', '/admin/settings',
  '/admin/integrations', '/admin/integrations/:id',
  '/admin/:resource', '/admin/:resource/:id',
];

export const ROUTE_PATHS = Object.freeze(['/', ...SUPPORT_PAGES.map((p) => supportPath(p)), '*']);
